import React from 'react';
interface ScrollToSectionProps {
  to: string;
  children: React.ReactNode;
}
const ScrollToSection: React.FC<ScrollToSectionProps> = ({
  to,
  children
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const id = to.replace('#', '');
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };
  return <a href={to} onClick={handleClick} className="inline-block" data-id="element-130">
      {children}
    </a>;
};
export default ScrollToSection;